import { fetchHandler, HTTP_METHOD, limiter, API_VERSION_ESYMANDANT } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiFilestreamResponse } from 'application/api/response_handlers'

export const getMainLogoByAccountId = (accountId) => {
    const request = fetchRequestBuilder(`${API_VERSION_ESYMANDANT}/e.consult.${accountId}/accounts/logo`, HTTP_METHOD.GET)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiFilestreamResponse)
}